import React from 'react';
import { SurveyQuestion } from './SurveyQuestion';

export const SurveyDropdown = ({ option, hasVoted, onOptionUpdated }) => {
    const handleSelect = (event) => {
        onOptionUpdated(option.ballotOptionId, event.target.value)
    };

    return (
        <React.Fragment>
            <SurveyQuestion option={option} />
            <select name={option.ballotOptionId}
                id={option.ballotOptionId}
                disabled={hasVoted}
                onChange={handleSelect}
                className="w-fit"
                value={option.textValue != null ? option.textValue : ''}>
                <option value="">Select an option...</option>
                {option.surveyOptions.map((surveyOption) =>
                    <option key={surveyOption} value={surveyOption}>{surveyOption}</option>
                )}
            </select>
        </React.Fragment>
    );
}